import * as React from "react";
import { IUser } from "../auth/models/User";
import { useState } from "react";
import { ICurrent } from "../auth/models/Current";

export interface IGlobalContext {
    user: IUser | null;
    setUser: (user: IUser | null) => void;
    userLoaded: boolean;

    current: ICurrent | null;
    setCurrent: (current: ICurrent | null) => void;

    tenantSwitchModal: {
        open: boolean;
        onChange: (value: boolean) => void;
    };
}

export const GlobalContext = React.createContext<IGlobalContext>({
    user: null,
    setUser: () => {},
    userLoaded: false,
    current: null,
    setCurrent: () => {},
    tenantSwitchModal: {
        open: false,
        onChange: () => {},
    },
});

export const GlobalContextProvider = (props: any) => {
    const [user, setUser] = useState<IUser | null | undefined>(undefined);
    const [current, setCurrent] = useState<ICurrent | null | undefined>(
        undefined
    );
    const [tenantSwitchModalOpen, setTenantSwitchModal] = useState(false);

    return (
        <GlobalContext.Provider
            value={{
                user: user || null,
                setUser,
                userLoaded: user !== undefined,
                current: current || null,
                setCurrent,
                tenantSwitchModal: {
                    open: tenantSwitchModalOpen,
                    onChange: setTenantSwitchModal,
                },
            }}
        >
            {props.children}
        </GlobalContext.Provider>
    );
};
